import { render, staticRenderFns } from "./ModalViewRequest.vue?vue&type=template&id=57352cd6&"
import script from "./ModalViewRequest.vue?vue&type=script&lang=js&"
export * from "./ModalViewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports